import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
// import { MobileTopHeader } from "../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
// import { SliderReusableComponent } from "../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
// import { BackLogoIconButton } from "../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { ReusableOnboardingButton } from "../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
// import Media from "react-media";
import LeftSideNavigation from "../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import isEmpty from "../../../store/validation/is-Empty";

export const AdminScreenDescription = (props) => {
  let history = useHistory();
  const editAction = useSelector((state) => {
    return !isEmpty(
      state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData
    )
      ? state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData
      : false;
  });
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="col-6 pl-5 pr-5 pt-5">
              <div className="bank_and_other_details_onboarding_main">
                <div id="onboarding-scrollbar" className="">
                  <div>
                    <div className="f24_700_HelveticaNeue pb-5">
                      Subscription
                    </div>
                    <div
                      id="style-4"
                      style={{
                        height: "52vh",
                        maxWidth: 500,
                        overflowY: "auto",
                      }}
                    >
                      <div className="f18-700 mb-3">
                        Key Points about you that Customer Must Be Aware Of:{" "}
                      </div>
                      <p className="f12-400 opacity5 pb-3">
                        You can select the category in which your business (e.g.
                        Casual/Fine dine, Fast Food and other, Hospitality &
                        Hotels) and turn the toggles on for the services
                        applicable to your outlet so that the users take full
                        advantage of them.
                      </p>
                      <p className="f12-400 opacity5 pb-3">
                        You can select the seating management subscription
                        options that are applicable to your outlet (e.g. general
                        settings, walk-in/waitlist, reservations, and table
                        management) by turning on the toggle.
                      </p>
                      <p className="f12-400 opacity5 pb-3">
                        You can turn on the toggle for Offers management if you
                        wish to provide the user with certain online/offline
                        offers.
                      </p>
                      <p className="f12-400 opacity5 pb-3">
                        Online/offline event options can also be enabled in the
                        event management settings to allow users to book
                        online/offline events.
                      </p>
                      <p className="f12-400 opacity5 pb-3">
                        If you provide scan and pay as a payment option at your
                        outlet, you can enable to toggle here.
                      </p>
                      <p className="f12-400 opacity5 pb-3">
                        Live streaming for the users can also be set up by
                        enabling the toggle so that the users can get the live
                        footage of their food being prepared.
                      </p>
                      <p className="f12-400 opacity5 pb-3">
                        Maintaining these subscription settings will be the key
                        for a smooth experience for you as these settings will
                        depict all the services that you enable or disable at
                        your outlet.
                      </p>
                    </div>
                  </div>
                  <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                    {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                    <ReusableOnboardingButton
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      onClick={(e) =>
                        history.push(
                          editAction
                            ? "/admin_edit_bankdetails"
                            : "/addvendorbankdetails"
                        )
                      }
                    />
                    <ReusableOnboardingButton
                      buttonTitle="Next Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                      buttonText="Next"
                      onClick={(e) =>
                        history.push(
                          editAction
                            ? "/admin-edit-add-subscription"
                            : "/admin-add-subscription"
                        )
                      }
                    />
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdminScreenDescription;
